import Image from 'next/legacy/image';

import { H3, H5 } from '@common/headline';

import articlesAppPreview from '@public/img/how-it-works/articles-app-preview.png';

export const ArticlesSupportingTheScience = (): JSX.Element => (
  <div className="flex flex-col lg:flex-row-reverse lg:items-center">
    <div className="lg:w-[50%] lg:pl-[5%]">
      <div className="mx-3 lg:max-w-[450px]">
        <H3>
          Articles supporting the science and psychology behind eating patterns
        </H3>
      </div>
      <div className="mx-3 mt-4 lg:max-w-[450px]">
        <H5>
          Read or listen to daily educational articles to help you learn more
          about the science of nutrition and the psychology of building habits.
        </H5>
      </div>
    </div>
    <div className="mt-10 pl-1.5 lg:mt-0 lg:w-[50%] lg:pl-0">
      <Image
        src={articlesAppPreview}
        width={1053}
        height={1104}
        objectFit="contain"
        alt="Articles app preview"
      />
    </div>
  </div>
);
